import 'phaser'
import { stevieCam } from '../engine/stevieCam-sidecar'
import { IEntity } from '../entities/entitiesUtils'
import { IMachineData, IMachinePlaceRule } from '../machines/machinesData'
import { createId } from '../main/common'
import { common } from '../main/common-sidecar'
import { fi32, IFrameInfo } from '../main/frameInfo'
import { layers } from '../main/layers-sidecar'
import { scene } from '../main/scene-sidecar'
import { spriteMap } from '../main/spriteMap-sidecar'
import { tileMapShip } from '../tiles/tileMapShip-sidecar'
import { tilesDataShip } from '../tiles/tilesDataShip-sidecar'
import { ITileShip } from '../tiles/tilesShip'
import { machines } from '../machines/machines-sidecar'
import { blueprints } from '../blueprints/blueprints-sidecar'
import { stacks } from '../entities/stacks-sidecar'

export interface IMachinePlaceSpot extends IEntity {
  image: Phaser.GameObjects.Image
  rule: IMachinePlaceRule | null
  isValid: boolean
}
export interface IMachinePlacer extends IEntity {
  isVisible: boolean
  spots: IMachinePlaceSpot[]
}

let _data: IMachinePlacer | null = null
export const getData = () => {
  if (!_data) {
    _data = {
      id: createId(),
      isDead: false,
      eType: 'machine-placer',
      isVisible: false,
      spots: [],
    }
  }
  return _data
}

const createSpot = (rule: IMachinePlaceRule): IMachinePlaceSpot => {
  let image = spriteMap.createImageFromFrameInfo(
    layers.getLayers().uiOnCam,
    frames[1],
    0,
    0,
  )

  let obj: IMachinePlaceSpot = {
    id: createId(),
    isDead: false,
    eType: 'machine-placer-part',
    rule,
    image,
    isValid: false,
  }
  return obj
}

let frames: IFrameInfo[] = [fi32(8, 5, 1), fi32(8, 5, 2)]

export function setVisible(isVisible: boolean) {
  getData().isVisible = isVisible
}

export function setToMachineData(data: IMachineData | null) {
  let d = getData()

  for (let idx = 0; idx < d.spots.length; idx++) {
    let s = d.spots[idx]
    s.rule = null
  }
  if (data) {
    for (let idx = 0; idx < data.placeRules.length; idx++) {
      d.isVisible = true

      // Create a spot
      let rule = data.placeRules[idx]
      if (d.spots.length > idx) {
        let s = d.spots[idx]
        s.rule = rule
      } else {
        d.spots.push(createSpot(rule))
      }
    }
  }
}

export function updateAll() {
  let d = getData()
  let sc = common.getPhaserScene()

  let cam = stevieCam.get()
  let tm = scene.getContext().mapShip

  let t = tileMapShip.getTileAtMouse(
    tm,
    sc.input.mousePointer.x,
    sc.input.mousePointer.y,
  )
  checkValid(t)
}

export function checkValid(t: ITileShip | null) {
  let d = getData()
  let std = tilesDataShip.getStandard()
  let ctx = scene.getContext()

  if (!t) {
    return false
  }

  let isValid = true

  for (let idx = 0; idx < d.spots.length; idx++) {
    let spot = d.spots[idx]

    if (!spot.rule) {
      spot.isValid = true
      spot.image.visible = false
      continue
    }

    spot.image.x = t.x + spot.rule.oi * 4 * 8
    spot.image.y = t.y + spot.rule.oj * 4 * 8
    spot.image.visible = true

    let ip = t.i + spot.rule.oi
    let jp = t.j + spot.rule.oj

    let tCheck = tileMapShip.getTile(ctx.mapShip, ip, jp)
    spot.isValid = false

    if (tCheck) {
      if (spot.rule.type === 'floor') {
        spot.isValid = tCheck.dataFloor === std.floor
      }
      if (spot.rule.type === 'hull') {
        spot.isValid = tCheck.dataFloor === std.hull
      }
      if (spot.rule.type === 'space') {
        spot.isValid = tCheck.dataFloor === null
      }
    }

    if (spot.isValid) {
      // Check for stuff in the way
      if (machines.findAtSpot(ip, jp, (c) => true)) {
        spot.isValid = false
      }
      if (blueprints.findAtSpot(ip, jp, (c) => true)) {
        spot.isValid = false
      }
      if (stacks.findAtSpot(ip, jp, (c) => true)) {
        spot.isValid = false
      }
    }

    if (!spot.isValid) {
      isValid = false
    }

    spriteMap.setFrame(spot.image, frames[spot.isValid ? 0 : 1])
  }
  return isValid
}
